import { IconButton, Tooltip } from "@mui/material";

import BadgeEstados from "../../../../components/BadgeEstado";
import { EyeIcon } from "../../../../components/Icons";
import HeaderColumn from "../../../Actas/components/HeaderColumn";
import { format, parse } from "date-fns";

export const tableData = (
  data,
  setFiltersField,
  setOrder,
  setOrderField,
  coleccionActasDetalle,
  setAllActaDetalle,
  handlerModal,
  getActaDetalle,
  filterEstado
) => {
  console.log(filterEstado);
  
  const headerFecha = {
    "no-notificadas": "Fecha No Notificada",
    "notificadas": "Fecha Notificacion",
    "reparto": "Fecha Asignacion",
  }[filterEstado] || "Fecha Reporte";
  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    {
      field: "numero_acta",
      headerName: "Acta",
      // minWidth: 110,
      width: "130",
      // flex: 1,
      sortable: true,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"number"}
      //       field={"numero_acta"}
      //       place={"Acta"}
      //     />
      //   );
      // },
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "localidad",
      headerName: "Localidad",
      minWidth: 170,
      flex: 1,
      sortable: true,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"text"}
      //       field={"localidad"}
      //       place={"Localidad"}
      //     />
      //   );
      // },
    },
    // {
    //   field: "notificador_nombre",
    //   headerName: "Notificador",
    //   width: 320,
    //   flex: 1,
    //   sortable: true,
    //   renderHeader: () => {
    //     return (
    //       <HeaderColumn
    //         setFiltersField={setFiltersField}
    //         setOrder={setOrder}
    //         setOrderField={setOrderField}
    //         typeInput={"text"}
    //         field={"nombre_notificador"}
    //         place={"Notificador"}
    //       />
    //     );
    //   },
    // },
    {
      // in:reparto,notificadas,no-notificadas
      field: "fecha_reporte",
      headerName: headerFecha,
      // minWidth: 100,
      // flex: 1,
      width: "200",
      sortable: true,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"text"}
      //       field={"fecha_reporte"}
      //       place={"Fecha reporte"}
      //     />
      //   );
      // },
      renderCell: (params) => {
        const fechaFormateada = format(
          parse(params?.row?.fecha_reporte, "dd/MM/yyyy HH:mm:ss", new Date()),
          "dd/MM/yy HH:mm"
        );
        if (!params.row.fecha_reporte) {
          return <BadgeEstados estado_id={params.row.estado_id} />;
        } else {
          // return <span>{params.row.fecha_reporte}</span>;
          return <span>{fechaFormateada}</span>;
        }
      },
    },
    {
      field: "estado_id",
      headerName: "Estado",
      // minWidth: 300,
      width: "50",
      flex: 1,
      sortable: true,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"select"}
      //       reportes={true}
      //       field={"estado_id"}
      //       place={"Estado"}
      //     />
      //   );
      // },
      renderCell: (params) => {
        return <BadgeEstados estado_id={params.row.estado_id} />;
      },
    },
    // {
    //   field: "actions",
    //   headerName: "Acciones",
    //   minWidth: 120,
    //   flex: 1,
    //   renderCell: (params) => {
    //     return (
    //       <Tooltip title="Ver detalle" arrow>
    //         <IconButton
    //           onClick={() => {
    //             const actaDetalle = coleccionActasDetalle?.find(
    //               (acta) => acta?.acta.id == params.row.id
    //             );
    //             if (actaDetalle) {
    //               setAllActaDetalle(actaDetalle);
    //               handlerModal({ modal: true, modalName: "acta_detalle" });
    //             } else {
    //               getActaDetalle(params.row.id);
    //             }
    //           }}
    //         >
    //           <EyeIcon />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // },
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: d?.id,
        fecha_hora: d?.fecha_hora,
        numero_acta: d?.numero_acta,
        localidad: d?.localidad,
        fecha_reporte: d?.fecha_reporte,
        notificador_nombre: d?.nombre_notificador || null,
        estado_id: d?.estado_id || null,
        fecha_notificacion: d?.fecha_notificacion || null,
        motivo: d?.motivo || null,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
